module.exports = __webpack_public_path__ + "img/empty-image-error.7c88c8a2.png";